(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["AMP"] = factory();
	else
		root["AMP"] = factory();
})((typeof ArcSDK !== 'undefined' ? ArcSDK : this), function() {
return 